import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getParameterByCode } from 'slices/parameter'
import { STATICS } from 'statics'
import { PARAMETERS_CODE } from 'app-constants'
import { useToaster } from 'hooks'
import { FaqInputSearch } from 'components'
import { FAQ_ERROR_MESSAGE } from '../../constants'
import './style.scss'

export function DashboardFaq() {
  const dispatch = useDispatch()
  const { parameters } = useSelector(state => state)
  const { showErrorToast } = useToaster()

  useEffect(() => {
    dispatch(getParameterByCode(PARAMETERS_CODE.ENABLE_SEARCH_FAQ_AI))
  }, [dispatch])

  function showErrorMessage() {
    showErrorToast(FAQ_ERROR_MESSAGE)
  }

  function renderContent() {
    const isSearchFaqEnabled = parameters[PARAMETERS_CODE.ENABLE_SEARCH_FAQ_AI]

    if (!isSearchFaqEnabled) return null

    return (
      <div className='container-dashboard-faq'>
        <div className='container-image'>
          <img src={STATICS.FAQ_DASHBOARD} className='image' alt='Imagem de ajuda da Giga+.' />
        </div>
        <div className='container-input'>
          <FaqInputSearch onError={showErrorMessage} />
        </div>
      </div>
    )
  }

  return renderContent()
}
